import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_ROUTE_NAME = Symbol('admin.affiliates.approved.none-negative-carryover');
export const TRANSLATION_GROUP_AFFILIATES_NONE_NEGATIVE_CARRYOVER = Symbol('admin.affiliates.approved.none-negative-carryover');

export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_QUERY = 'affiliate.show-none-negative-carryover';
export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_API_URL = 'admin/affiliates/:id/show_nnco';

export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_CREATE_MUTATION = 'affiliate.create-none-negative-carryover';
export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_CREATE_API_URL = 'admin/history_of_nncos_changes';

export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_DELETE_MUTATION = 'affiliate.delete-none-negative-carryover';
export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_DELETE_API_URL = 'admin/history_of_nncos_changes/:itemId';

export const AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS = {
  CREATE: new Permission(
    PermissionsList.admin.HISTORY_OF_NNCO_CHANGES_CHANGES_CREATE,
  ),
  EDIT: new Permission(
    PermissionsList.admin.HISTORY_OF_NNCO_CHANGES_CHANGES_EDIT,
  ),
  DELETE: new Permission(
    PermissionsList.admin.HISTORY_OF_NNCO_CHANGES_CHANGES_DELETE,
  ),
};
